export function getCategoryList(data) {
    let { getCategoryListRequest, getCategoryListError, getCategoryListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/category/list',
        this.createBundle('app/category/list', { data: data }, this.GET, getCategoryListRequest, getCategoryListResult, getCategoryListError)
    )
}
